import logo from "../../assets/img/logo-elecciones-colombia.png";
import "./Resume.scss";

const Resume = ({ votes, bulletin }) => {
  const { votesTotal, votesAnnulled, votesBlank, votesInvalid } = votes;
  const { bulletinGeneral, deskTotal, deskInformation, desckScreened } = bulletin;
  return (
    <div>
      <section className="resume">
        <div className="resume__logo">
          <img className="resume__logo-img" src={logo} alt="Elecciones colombia" />
        </div>
        <div className="bulletin">
          <div className="bulletin__separator-horizontal-d"></div>
          <div className="bulletin__data">
            BOLETÍN: <span> {bulletinGeneral}</span>
          </div>
          <div className="bulletin__separator-vertical"></div>
          <div className="bulletin__data">
            MESAS TOTALES: <span> {deskTotal} </span>
          </div>
          <div className="bulletin__separator-horizontal"></div>
          <div className="bulletin__data">
            MESAS INFORMADAS: <span> {deskInformation} </span>
          </div>
        </div>

        <div className="resume__desktop-separator"></div>
        <div className="resume__votes">
          <div className="resume__votes-top">
            <div className="resume__votes-data">
              VOTOS TOTALES <span> {votesTotal} </span>
            </div>
            <div className="resume__votes-separator"></div>
            <div className="resume__votes-data">
              MESAS ESCRUTADAS (%) <span> {desckScreened}% </span>
            </div>
          </div>
          <div className="resume__separator"></div>
          <div className="resume__votes-bot">
            <div className="resume__votes-data">
              VOTOS NULOS <span> {votesAnnulled} </span>
            </div>
            <div className="resume__votes-separator"></div>
            <div className="resume__votes-data">
              VOTOS EN BLANCO <span> {votesBlank} </span>
            </div>
            <div className="resume__votes-separator"></div>
            <div className="resume__votes-data">
              VOTOS NO VÁLIDOS <span> {votesInvalid} </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resume;
